import BreadCrumbsHOC, { BreadCrumbProps } from '@components/UI/breadcrumbs';
import { useBitrix } from '@context/useBitrixUser/useBitrix';
import Typography from '@mui/material/Typography';
import { dealPageService } from '@services/requests/dealPageService';
import { DealDocumentsResponse } from '@services/requests/dealPageService/types/documentsData';
import React, { useEffect, useState } from 'react';

import { DocumentsTabSkeleton } from './components/DealPageTabs/DocumentsTab/DocumentsTabSkeleton';
import { DealPageTabsContainer } from './components/DealPageTabsContainer';
import { getDealIdFromPath } from './helpers';
import { DealPageStyledContainer } from './StyledComponents';

function DealPage() {
  const [documentsData, setMainData] = useState<DealDocumentsResponse | null>(null);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);
  const [errors, setErrors] = useState<string[]>([]);

  const { useBitrixUser } = useBitrix();
  const [{ bitrixUser, isUserLoading }] = useBitrixUser().useState();

  const breadCrumbs: BreadCrumbProps[] = (documentsData?.data?.breadcrumbs ?? []).map(
    (b, index) => ({
      id: index,
      name: b.title,
      url: b.path,
      isRedirect: true,
    })
  );

  useEffect(() => {
    if (!bitrixUser && !isUserLoading) {
      setIsDataLoading(false);
    }
    if (!bitrixUser || isUserLoading) {
      return;
    }
    const dealId = getDealIdFromPath();
    const fetchData = async () => {
      const result = await dealPageService().LoadDealDocumentsData(dealId);

      if ('message' in result) {
        setIsDataLoading(false);
        setErrors(['Ошибка']);
        return;
      }

      setIsDataLoading(false);
      setMainData(result);
    };
    fetchData();
  }, [bitrixUser, isUserLoading]);

  if (errors.length > 0) {
    return (
      <DealPageStyledContainer component={'section'}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {errors.map((error, index) => (
            <div key={'error-' + index}>
              <span className="company-status error">{error}</span>
            </div>
          ))}
        </div>
      </DealPageStyledContainer>
    );
  }

  if (isDataLoading) {
    return <DocumentsTabSkeleton />;
  }

  if (!documentsData || !documentsData.success) {
    return null;
  }

  return (
    <DealPageStyledContainer component={'section'}>
      <BreadCrumbsHOC crumbs={breadCrumbs} />
      <div className="header">
        <Typography variant={'h1'} color={'common.black'} className={'title'}>
          {documentsData.data.title}
        </Typography>
        <div className="deal-status-wrapper">
          {documentsData.data.status.map((s, index) => (
            <span key={'status-' + index} className="deal-status">
              {s.title}
            </span>
          ))}
        </div>
      </div>
      <DealPageTabsContainer documentsData={documentsData.data} isAllowEdit={true} />
    </DealPageStyledContainer>
  );
}

export { DealPage };
